import Profile from "../features/profile/Profile";

const DealerProfilePage = () => {
  return <Profile />;
};

export default DealerProfilePage;
